import {colors} from 'shells/colors/colors';
import {ArrowRightThinIcon} from 'shells/icon/svg/arrow-right-thin-icon';
import {Stack} from 'shells/layout/stack/stack';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import {Body} from 'shells/typography/body';

import type {SelectPickerOption} from './branching-rules';

const ROW_WIDTH = '150px';
interface Props {
    fieldOption: string;
    rule: SelectPickerOption | null;
    ruleOptions: SelectPickerOption[];
    onRuleOptionChange: (ruleOption: SelectPickerOption) => void;
}

export function BranchingRow(props: Props) {
    return (
        <Stack isHorizontal={true} justifyContent='space-between' alignItems='center'>
            <div className='border br-3 py-6 px-8' style={{width: ROW_WIDTH}}>
                <Body size='small'>{props.fieldOption}</Body>
            </div>
            {/* @ts-expect-error */}
            <ArrowRightThinIcon size={18} color={colors.placeholder} />
            <SelectPickerGeneric
                options={props.ruleOptions}
                isSearchable={true}
                placeholder='Choose a rule…'
                value={props.rule ?? undefined}
                valueKey='id'
                onChange={(option: SelectPickerOption) => props.onRuleOptionChange(option)}
                styles={{
                    control: (base: any) => ({
                        ...base,
                        width: ROW_WIDTH,
                    }),
                }}
            />
        </Stack>
    );
}
